/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
/**
 * @license simple-loop https://github.com/flams/simple-loop
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014-2015 Olivier Scherrer <pode.fr@gmail.com>
 */


function assert(assertion, error) {
  if (assertion) {
    throw new TypeError("simple-loop: " + error);
  }
}
/**
 * Small abstraction for looping over objects and arrays
 * Warning: it's not meant to be used with nodeList
 * To use with nodeList, convert to array first
 * @param {Array/Object} iterated the array or object to loop through
 * @param {Function} callback the function to execute for each iteration
 * @param {Object} scope the scope in which to execute the callback
 */


var simpleLoop = function loop(iterated, callback, scope) {
  assert(typeof iterated != "object", "iterated must be an array/object");
  assert(typeof callback != "function", "callback must be a function");
  var i;

  if (Array.isArray(iterated)) {
    for (i = 0; i < iterated.length; i++) {
      callback.call(scope, iterated[i], i, iterated);
    }
  } else {
    for (i in iterated) {
      if (iterated.hasOwnProperty(i)) {
        callback.call(scope, iterated[i], i, iterated);
      }
    }
  }
};

function assert$1(assertion, error) {
  if (assertion) {
    throw new TypeError("simple-loop: " + error);
  }
}
/**
 * Make a diff between two objects
 * @param {Array/Object} base the base object
 * @param {Array/Object} compared the object to compare the base with
 * @example:
 *  With objects:
 *
 *  base = {a:1, b:2, c:3, d:4, f:6}
 *  compared = {a:1, b:20, d: 4, e: 5}
 *  will return :
 *  {
 *      unchanged: ["a", "d"],
 *      updated: ["b"],
 *      deleted: ["f"],
 *      added: ["e"]
 *  }
 *
 * It also works with Arrays:
 *
 *  base = [10, 20, 30]
 *  compared = [15, 20]
 *  will return :
 *  {
 *      unchanged: [1],
 *      updated: [0],
 *      deleted: [2],
 *      added: []
 *  }
 *
 * @returns object
 */


var shallowDiff = function shallowDiff(base, compared) {
  assert$1(typeof base != "object", "the first object to compare with shallowDiff needs to be an object");
  assert$1(typeof compared != "object", "the second object to compare with shallowDiff needs to be an object");
  var unchanged = [],
      updated = [],
      deleted = [],
      added = []; // Loop through the compared object

  simpleLoop(compared, function (value, idx) {
    // To get the added items
    if (!(idx in base)) {
      added.push(idx); // The updated items
    } else if (value !== base[idx]) {
      updated.push(idx); // And the unchanged
    } else if (value === base[idx]) {
      unchanged.push(idx);
    }
  }); // Loop through the before object

  simpleLoop(base, function (value, idx) {
    // To get the deleted items
    if (!(idx in compared)) {
      deleted.push(idx);
    }
  });
  return {
    updated: updated,
    unchanged: unchanged,
    added: added,
    deleted: deleted
  };
};

var find = function find(array, fn) {
  for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
    var item = array_1[_i];

    if (fn(item)) {
      return item;
    }
  }

  return null;
};

var immer;

try {
  // @ts-ignore
  // tslint:disable-next-line no-var-requires
  immer = require('immer');
} catch (_a) {
  immer = null;
}

var immer$1 = immer;

var getTasks = function getTasks(state) {
  if (!('tasks' in state)) {
    throw new Error('State not initialized for Redux Agent. ' + 'Did you call reduceReducers(..., taskReducer)?');
  }

  return state.tasks;
};

var addTask = function addTask(state, task) {
  var _a;

  var tasks = getTasks(state);
  var systemTask = tasks[0];

  if (immer$1 && immer$1.isDraft(state)) {
    systemTask.nextTaskId += 1;
    tasks[systemTask.nextTaskId] = task;
    return state;
  } else {
    var newTasks = _assign({}, tasks, (_a = {
      0: _assign({}, systemTask, {
        nextTaskId: systemTask.nextTaskId + 1
      })
    }, _a[systemTask.nextTaskId] = task, _a));

    return _assign({}, state, {
      tasks: newTasks
    });
  }
};

var delTasks = function delTasks(state, taskFilter) {
  var tasks = getTasks(state);

  if (immer$1 && immer$1.isDraft(state)) {
    for (var tid in tasks) {
      if (taskFilter(tasks[tid])) {
        delete tasks[tid];
      }
    }

    return state;
  } else {
    var newTasks = tasks;

    for (var tid in tasks) {
      if (taskFilter(tasks[tid])) {
        var _a = tid,
            removedTask = newTasks[_a],
            remainingTasks = __rest(newTasks, [typeof _a === "symbol" ? _a : _a + ""]);

        newTasks = remainingTasks;
      }
    }

    return _assign({}, state, {
      tasks: newTasks
    });
  }
};

var reducer = function reducer(state, action) {
  var s = 'tasks' in state ? state : _assign({}, state, {
    tasks: {
      0: {
        type: 'system',
        nextTaskId: 1
      }
    }
  }); // @ts-ignore

  if (action.meta && action.meta.taskId !== undefined && action.meta.final) {
    var _a = // @ts-ignore
    s.tasks,
        _b = action.meta.taskId,
        removedTask = _a[_b],
        remainingTasks = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);

    return _assign({}, s, {
      tasks: remainingTasks
    });
  } else {
    return s;
  }
};

var index = function index() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var initialState = typeof args[0] !== 'function' && args.shift();
  var reducers = args;

  if (typeof initialState === 'undefined') {
    throw new TypeError('The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.');
  }

  return function (prevState, value) {
    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    var prevStateIsUndefined = typeof prevState === 'undefined';
    var valueIsUndefined = typeof value === 'undefined';

    if (prevStateIsUndefined && valueIsUndefined && initialState) {
      return initialState;
    }

    return reducers.reduce(function (newState, reducer, index) {
      if (typeof reducer === 'undefined') {
        throw new TypeError('An undefined reducer was passed in at index ' + index);
      }

      return reducer.apply(undefined, [newState, value].concat(args));
    }, prevStateIsUndefined && !valueIsUndefined && initialState ? initialState : prevState);
  };
};

var _this = undefined;

var http = function http(config) {
  var baseUrl = config && config.baseUrl || '';
  var fetchDefaults = config && config.fetchDefaults || {};

  var perform = function perform(params, dispatch) {
    var url = params.url,
        actions = params.actions,
        fetchParams = __rest(params, ["url", "actions"]);

    var headers = new Headers(params.headers);

    if (!headers.has('accept')) {
      headers.append('accept', 'application/json');
    }

    var body;

    if (params.body && Object.prototype.toString.call(params.body) === '[object Object]') {
      headers.append('content-type', 'application/json');
      body = JSON.stringify(params.body);
    }

    fetch(baseUrl ? baseUrl + url : url, _assign({}, fetchDefaults, fetchParams, {
      body: body,
      headers: headers
    })).then(function (response) {
      return __awaiter(_this, void 0, void 0, function () {
        var contentType, data, _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              contentType = response.headers.get('content-type');
              if (!(contentType && contentType.indexOf('application/json') !== -1)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , response.json()];

            case 1:
              _a = _b.sent();
              return [3
              /*break*/
              , 4];

            case 2:
              return [4
              /*yield*/
              , response.text()];

            case 3:
              _a = _b.sent();
              _b.label = 4;

            case 4:
              data = _a;
              window.setTimeout(function () {
                // Ensure that errors occurring as part of dispatch()
                // (such as errors happening in the reducer) don't also
                // trigger the catch() handler below resulting in a double
                // dispatch.
                dispatch({
                  type: response.ok ? actions.success : actions.failure,
                  payload: data,
                  meta: {
                    status: response.status,
                    final: true
                  }
                });
              });
              return [2
              /*return*/
              ];
          }
        });
      });
    }).catch(function (err) {
      dispatch({
        type: actions.failure,
        meta: {
          status: 0,
          err: err,
          final: true
        }
      });
    });
  };

  return {
    perform: perform,
    type: 'http'
  };
};

var socket = function socket(config) {
  var createSocket = config && config.socketFactory ? config.socketFactory : function (url) {
    return new WebSocket(url);
  };
  var encoder = config && config.encode ? config.encode : JSON.stringify;
  var decoder = config && config.decode ? config.decode : JSON.parse;
  var socket = null;

  var perform = function perform(params, dispatch) {
    var initializeSocket = !socket;
    var actions = params.actions;

    if (initializeSocket) {
      var url = params.url;
      socket = createSocket(url);

      socket.onopen = function () {
        dispatch({
          type: actions.connect
        });
      };

      socket.onerror = function (err) {
        dispatch({
          type: actions.error,
          meta: {
            err: err
          }
        });
      };

      socket.onclose = function () {
        dispatch({
          type: actions.disconnect,
          meta: {
            final: true
          }
        });
      };

      socket.onmessage = function (_a) {
        var data = _a.data;
        dispatch({
          type: actions.message,
          payload: decoder(data)
        });
      };
    }

    var op = params.op;

    if (op === 'send') {
      // if socket connected, otherwise schedule for later
      socket.send(encoder(params.data));
      dispatch({
        type: actions.sent,
        meta: {
          final: true
        }
      });
    }

    if (initializeSocket) {
      return function cleanup() {
        socket.close();
        socket = null;
      };
    }
  };

  return {
    perform: perform,
    type: 'socket'
  };
};

var storage = function storage() {
  var perform = function perform(params, dispatch) {
    var op = params.op,
        actions = params.actions;

    switch (op) {
      case 'get':
        {
          // assert key
          var key = params.key;
          var data = window.localStorage.getItem(key);

          if (data !== null) {
            dispatch({
              type: actions.success,
              payload: JSON.parse(data),
              meta: {
                key: key,
                final: true
              }
            });
          } else {
            dispatch({
              type: actions.failure,
              meta: {
                key: key,
                final: true
              }
            });
          }

          break;
        }

      case 'set':
        {
          var key = params.key,
              data = params.data; // XXX assert key, data; find way of typing statically

          window.localStorage.setItem(key, JSON.stringify(data));
          dispatch({
            type: actions.success,
            meta: {
              key: key,
              final: true
            }
          });
          break;
        }

      case 'del':
        {
          var key = params.key;
          window.localStorage.removeItem(key);
          dispatch({
            type: actions.success,
            meta: {
              key: key,
              final: true
            }
          });
          break;
        }

      case 'pop':
        {
          var key = params.key;
          var data = window.localStorage.getItem(key);

          if (data !== null) {
            window.localStorage.removeItem(key);
            dispatch({
              type: actions.success,
              payload: JSON.parse(data),
              meta: {
                key: key,
                final: true
              }
            });
          } else {
            dispatch({
              type: actions.failure,
              meta: {
                key: key,
                final: true
              }
            });
          }

          break;
        }

      case 'merge':
        {
          var key = params.key,
              data = params.data;
          var savedData = window.localStorage.getItem(key);

          if (savedData) {
            window.localStorage.setItem(key, JSON.stringify(_assign({}, JSON.parse(savedData), data)));
          } else {
            window.localStorage.setItem(key, JSON.stringify(data));
          }

          dispatch({
            type: actions.success,
            meta: {
              key: key,
              final: true
            }
          });
          break;
        }
    }
  };

  return {
    perform: perform,
    type: 'storage'
  };
};

var timer = function timer() {
  var perform = function perform(params, dispatch) {
    var actions = params.actions,
        interval = params.interval;
    var timerId = window.setInterval(function () {
      return dispatch({
        type: actions.tick
      });
    }, interval || 1000);
    return function cleanup() {
      window.clearInterval(timerId);
    };
  };

  return {
    perform: perform,
    type: 'timer'
  };
};

var rng = function rng() {
  var perform = function perform(params, dispatch) {
    var actions = params.actions;
    dispatch({
      type: actions.result,
      payload: Math.random(),
      meta: {
        final: true
      }
    });
  };

  return {
    perform: perform,
    type: 'rng'
  };
};

var configureAgents = function configureAgents(agents, store) {
  var currentTasks = {};
  var cleanupers = {};

  var dispatch = function dispatch(tid) {
    return function (action) {
      return store.dispatch(_assign({}, action, {
        meta: _assign({}, action.meta, {
          taskId: tid
        })
      }));
    };
  };

  return function () {
    var previousTasks = currentTasks; // @ts-ignore

    currentTasks = store.getState().tasks;

    if (previousTasks !== currentTasks) {
      var _a = shallowDiff(previousTasks, currentTasks),
          added = _a.added,
          deleted = _a.deleted;

      added.forEach(function (tid) {
        var task = currentTasks[tid];

        if (task.type === 'system') {
          return;
        }

        var handler = find(agents, function (h) {
          return h.type === task.type;
        });

        if (!handler) {
          throw new Error("No handler for task type \"" + task.type + "\"");
        }

        var cleanup = handler.perform(task, dispatch(tid), handler.config);

        if (cleanup) {
          cleanupers[tid] = cleanup;
        }
      });
      deleted.forEach(function (tid) {
        if (tid in cleanupers) {
          var cleanup = cleanupers[tid];
          delete cleanupers[tid];
          cleanup();
        }
      });
    }
  };
};

export { addTask, configureAgents, http as createHttpAgent, rng as createRngAgent, socket as createSocketAgent, storage as createStorageAgent, timer as createTimerAgent, delTasks, index as reduceReducers, reducer as taskReducer };